const isNum = (v) => typeof v === 'number';

export { isNum };
